'use client';

import React from 'react';
import Link from 'next/link';
import { LayoutDashboard, Map, BookOpen, BarChart3, Settings } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const MOBILE_NAV = [
  { id: 'mob-dashboard', label: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { id: 'mob-roadmap', label: 'Roadmap', href: '/roadmap-view', icon: Map },
  { id: 'mob-week', label: 'This Week', href: '/week-detail-view', icon: BookOpen },
  { id: 'mob-progress', label: 'Progress', href: '/dashboard', icon: BarChart3 },
  { id: 'mob-settings', label: 'Settings', href: '/dashboard', icon: Settings },
];

interface MobileNavProps {
  currentPath: string;
}

export default function MobileNav({ currentPath }: MobileNavProps) {
  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '64px',
        backgroundColor: 'var(--bg-card)',
        borderTop: '1px solid var(--border)',
        display: 'flex',
        alignItems: 'center',
        zIndex: 50,
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {MOBILE_NAV.map(item => {
        const Icon = item.icon;
        const isActive = currentPath === item.href;
        return (
          <Link
            key={item.id}
            href={item.href}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '3px',
              padding: '8px 4px',
              textDecoration: 'none',
              color: isActive ? 'var(--accent)' : 'var(--text-muted)',
              transition: 'color 150ms ease',
            }}
          >
            <Icon size={20} />
            <span style={{ fontSize: '10px', fontWeight: 500 }}>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}